import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-empty',
  template: `
    <app-navigation-empty
      [transparent]="transparent"
    ></app-navigation-empty>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationEmptyComponent implements OnInit {
  transparent: boolean;

  ngOnInit() {
    // Note: this is a hack for allowing us to set transparent navigation
    // if the PHP template variable transparent_header is set to true.
    if ((<any>window).webappCompat['navigation-empty']) {
      this.transparent = (<any>window).webappCompat[
        'navigation-empty'
      ].transparent;
    }
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/compat/compat-navigation-empty.component.ts